import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-based sessions: always send the httpOnly auth cookie with requests.
axios.defaults.withCredentials = true;

export const photoUrl = (path) => (path ? `${API}/files/${path}` : null);

export const api = {
  list: () => axios.get(`${API}/members`).then((r) => r.data),
  create: (data) => axios.post(`${API}/members`, data).then((r) => r.data),
  update: (id, data) => axios.put(`${API}/members/${id}`, data).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/members/${id}`).then((r) => r.data),
  link: (id, data) => axios.post(`${API}/members/${id}/link`, data).then((r) => r.data),
  unlink: (id, data) => axios.post(`${API}/members/${id}/unlink`, data).then((r) => r.data),
  setParents: (id, parent_ids) => axios.post(`${API}/members/${id}/set-parents`, { parent_ids }).then((r) => r.data),
  adoptSpouseChildren: (id) => axios.post(`${API}/members/${id}/adopt-spouse-children`, {}).then((r) => r.data),
  combineUnionChildren: (id) => axios.post(`${API}/members/${id}/combine-union-children`, {}).then((r) => r.data),
  resetLayout: () => axios.post(`${API}/members/reset-layout`, {}).then((r) => r.data),
  uploadPhoto: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios
      .post(`${API}/members/${id}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
  uploadGalleryPhoto: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/members/${id}/gallery`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  deleteGalleryPhoto: (id, path) => axios.post(`${API}/members/${id}/gallery/delete`, { path }).then((r) => r.data),
  setGalleryAvatar: (id, path) => axios.post(`${API}/members/${id}/gallery/avatar`, { path }).then((r) => r.data),
  setPhotoMeta: (id, path, caption, year) => axios.post(`${API}/members/${id}/gallery/meta`, { path, caption, year }).then((r) => r.data),
  listFrames: () => axios.get(`${API}/frames`).then((r) => r.data),
  createFrame: (data) => axios.post(`${API}/frames`, data).then((r) => r.data),
  updateFrame: (id, data) => axios.put(`${API}/frames/${id}`, data).then((r) => r.data),
  deleteFrame: (id) => axios.delete(`${API}/frames/${id}`).then((r) => r.data),
  createContribRequest: (name, note, family) => axios.post(`${API}/contrib-requests`, { name, note, family }).then((r) => r.data),
  listContribRequests: () => axios.get(`${API}/contrib-requests`).then((r) => r.data),
  approveContribRequest: (id) => axios.post(`${API}/contrib-requests/${id}/approve`, {}).then((r) => r.data),
  declineContribRequest: (id) => axios.post(`${API}/contrib-requests/${id}/decline`, {}).then((r) => r.data),
  deleteContribRequest: (id) => axios.delete(`${API}/contrib-requests/${id}`).then((r) => r.data),
  getPaymentConfig: () => axios.get(`${API}/payments/config`).then((r) => r.data),
  createDonationOrder: (data) => axios.post(`${API}/payments/create-order`, data).then((r) => r.data),
  captureOrder: (order_id) => axios.post(`${API}/payments/capture-order`, { order_id }).then((r) => r.data),
  listDonations: () => axios.get(`${API}/payments`).then((r) => r.data),
  analyzeNotes: (data) => axios.post(`${API}/analyze-notes`, data).then((r) => r.data),
  autofillPerson: (text) => axios.post(`${API}/autofill-person`, { text }).then((r) => r.data),
  geocode: (place) => axios.post(`${API}/geocode`, { place }).then((r) => r.data),
  importParse: (text, ancestor_name) => axios.post(`${API}/import/parse`, { text, ancestor_name }).then((r) => r.data),
  importCommit: (data) => axios.post(`${API}/import/commit`, data).then((r) => r.data),
  duplicates: () => axios.get(`${API}/duplicates`).then((r) => r.data),
  merge: (keepId, otherId) => axios.post(`${API}/members/${keepId}/merge`, { other_id: otherId }).then((r) => r.data),
  storyScript: (id, force = false) => axios.post(`${API}/members/${id}/story-script`, { force }).then((r) => r.data),
  tts: (text, voice) => axios.post(`${API}/tts`, { text, voice }).then((r) => r.data),
  voices: () => axios.get(`${API}/voices`).then((r) => r.data),
  cloneVoice: (name, file) => {
    const fd = new FormData();
    fd.append("name", name);
    fd.append("file", file);
    return axios.post(`${API}/voices/clone`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  exportStart: (member_ids, voice, music = true, music_style = "ambient", intro_outro = true) => axios.post(`${API}/story/export`, { member_ids, voice, music, music_style, intro_outro }).then((r) => r.data),
  exportStatus: (job) => axios.get(`${API}/story/export/${job}`).then((r) => r.data),
  geocodeStatus: () => axios.get(`${API}/geocode/status`).then((r) => r.data),
  login: (username, password) => axios.post(`${API}/auth/login`, { username, password }).then((r) => r.data),
  register: (name, email, password, origin) => axios.post(`${API}/auth/register`, { name, email, password, origin }).then((r) => r.data),
  forgotPassword: (email, origin) => axios.post(`${API}/auth/forgot-password`, { email, origin }).then((r) => r.data),
  resetPassword: (token, new_password) => axios.post(`${API}/auth/reset-password`, { token, new_password }).then((r) => r.data),
  googleSession: (session_id) => axios.post(`${API}/auth/google/session`, { session_id }).then((r) => r.data),
  getFamily: () => axios.get(`${API}/family`).then((r) => r.data),
  renameFamily: (name) => axios.put(`${API}/family`, { name }).then((r) => r.data),
  setFamilyPublic: (isPublic) => axios.post(`${API}/family/public`, { public: isPublic }).then((r) => r.data),
  setJoinLink: (enabled) => axios.post(`${API}/family/join-link`, { enabled }).then((r) => r.data),
  changeUserRole: (id, role) => axios.put(`${API}/auth/users/${id}/role`, { role }).then((r) => r.data),
  listSuggestions: () => axios.get(`${API}/suggestions`).then((r) => r.data),
  approveSuggestion: (id) => axios.post(`${API}/suggestions/${id}/approve`).then((r) => r.data),
  rejectSuggestion: (id) => axios.post(`${API}/suggestions/${id}/reject`).then((r) => r.data),
  listActivity: () => axios.get(`${API}/activity`).then((r) => r.data),
  getNotifications: () => axios.get(`${API}/notifications`).then((r) => r.data),
  getMyUpdates: () => axios.get(`${API}/my-updates`).then((r) => r.data),
  ackMyUpdates: () => axios.post(`${API}/my-updates/ack`).then((r) => r.data),
  publicTree: (slug) => axios.get(`${API}/public/${slug}/tree`).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`).then((r) => r.data),
  logout: () => axios.post(`${API}/auth/logout`, {}).then((r) => r.data),
  listUsers: () => axios.get(`${API}/auth/users`).then((r) => r.data),
  createUser: (data) => axios.post(`${API}/auth/users`, data).then((r) => r.data),
  deleteUser: (id) => axios.delete(`${API}/auth/users/${id}`).then((r) => r.data),
  changePassword: (current_password, new_password) => axios.post(`${API}/auth/change-password`, { current_password, new_password }).then((r) => r.data),
  emailPreview: (email, kind, origin) => axios.post(`${API}/auth/email-preview`, { email, kind, origin }).then((r) => r.data),
  setInviteReminders: (cfg) => axios.post(`${API}/settings/invite-reminders`, cfg).then((r) => r.data),
  resetUserPassword: (id, new_password) => axios.post(`${API}/auth/users/${id}/reset-password`, { new_password }).then((r) => r.data),
  createInvite: (data) => axios.post(`${API}/auth/invites`, data).then((r) => r.data),
  listInvites: () => axios.get(`${API}/auth/invites`).then((r) => r.data),
  revokeInvite: (id) => axios.delete(`${API}/auth/invites/${id}`).then((r) => r.data),
  inviteInfo: (token) => axios.get(`${API}/auth/invites/${token}/info`).then((r) => r.data),
  acceptInvite: (token, username, password, email, origin) => axios.post(`${API}/auth/invites/${token}/accept`, { username, password, email, origin }).then((r) => r.data),
  nameMatches: (name) => axios.post(`${API}/members/name-matches`, { name }).then((r) => r.data),
  getSettings: () => axios.get(`${API}/settings`).then((r) => r.data),
  uploadBackground: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/settings/background`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  clearBackground: () => axios.delete(`${API}/settings/background`).then((r) => r.data),
  setLineageColor: (root_id, color) => axios.post(`${API}/settings/lineage-color`, { root_id, color }).then((r) => r.data),
  setHomePerson: (member_id) => axios.post(`${API}/settings/home-person`, { member_id }).then((r) => r.data),
  getTreePrefs: () => axios.get(`${API}/prefs/tree`).then((r) => r.data),
  saveTreePrefs: (prefs) => axios.post(`${API}/prefs/tree`, prefs).then((r) => r.data),
  getAssistantHistory: () => axios.get(`${API}/assistant/history`).then((r) => r.data),
  clearAssistantHistory: () => axios.delete(`${API}/assistant/history`).then((r) => r.data),
  listGroups: () => axios.get(`${API}/groups`).then((r) => r.data),
  createGroup: (name, color) => axios.post(`${API}/groups`, { name, color }).then((r) => r.data),
  updateGroup: (id, data) => axios.put(`${API}/groups/${id}`, data).then((r) => r.data),
  deleteGroup: (id) => axios.delete(`${API}/groups/${id}`).then((r) => r.data),
  groupSetMember: (id, member_id, action) => axios.post(`${API}/groups/${id}/members`, { member_id, action }).then((r) => r.data),
  listThemes: () => axios.get(`${API}/themes`).then((r) => r.data),
  createTheme: (name, colors) => axios.post(`${API}/themes`, { name, colors }).then((r) => r.data),
  updateTheme: (id, data) => axios.put(`${API}/themes/${id}`, data).then((r) => r.data),
  deleteTheme: (id) => axios.delete(`${API}/themes/${id}`).then((r) => r.data),
  listNamePacks: () => axios.get(`${API}/name-packs`).then((r) => r.data),
  createNamePack: (name, gender, culture) => axios.post(`${API}/name-packs`, { name, gender, culture }).then((r) => r.data),
  deleteNamePack: (id) => axios.delete(`${API}/name-packs/${id}`).then((r) => r.data),
};

export const exportDownloadUrl = (job) => `${API}/story/export/${job}/download`;
export const audioUrl = (path) => (path ? `${API}/files/${path}` : null);
